// tslint:disable:variable-name
import { UserAccount } from './UserAccount';

export class UserSession {
    id: string;
    user_id: string;
    user_name: string;
    active: boolean;
    open_time: Date;
    request_time: Date;
    close_time: Date;
    address: string;
    client: string;
    user?: UserAccount;
    data?: any;
}
